import { format } from "date-fns";
import styles from "../../styles/_containers/_giftCards/table.module.scss";

const Table = ({ data }) => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2>Consumption History By Code</h2>
      </div>
      <div className={styles.tableWrapper}>
        <table>
          <thead>
            <tr>
              <th>Consumer</th>
              <th>Service</th>
              <th>Service Initial Price</th>
              <th>Balance Used</th>
              <th>Remaining Balance</th>
              <th>Used At</th>
            </tr>
          </thead>
          <tbody>
            {data.length === 0 && (
              <tr>
                <td colSpan={10}>
                  <p>לא בוצעו רכישות</p>
                </td>
              </tr>
            )}
            {data.map((i) => (
              <tr key={i._id}>
                <td>{i.userId.name}</td>
                <td>{i.serviceName}</td>
                <td>₪{i.serviceAmountOriginal}</td>
                <td>₪{i.balanceUsed}</td>
                <td>₪{i.userGiftCardId.remainingBalance}</td>
                <td>{format(new Date(i.createdAt), "dd/MM/yyyy")}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Table;
